import { tv } from 'tailwind-variants';

const displayStyles = tv({
    slots: {
        base: `
      iris:font-(family-name:--base-type-font-display)
      iris:font-(--sem-type-weight-display)!
      iris:tracking-(--sem-type-tracking-display)
      iris:text-(--comp-color-content-type-display)
    `,
        leading: "iris:leading-(--sem-type-leading-display)",
    },
    variants: {
        size: {
            md: `
        iris:text-(length:--sem-type-size-display-md-mobile)
        iris:lg:text-(length:--sem-type-size-display-md-desktop)
      `,
            lg: `
        iris:text-(length:--sem-type-size-display-lg-mobile)
        iris:lg:text-(length:--sem-type-size-display-lg-desktop)
      `,
            xl: `
        iris:text-(length:--sem-type-size-display-xl-mobile)
        iris:lg:text-(length:--sem-type-size-display-xl-desktop)
      `,
            xxl: `
        iris:text-(length:--sem-type-size-display-xxl-mobile)
        iris:lg:text-(length:--sem-type-size-display-xxl-desktop)
      `,
        },
        inverse: {
            true: "iris:text-(--comp-color-content-type-display-inverse)",
        },
    },
    defaultVariants: {
        size: "md",
        inverse: false,
    },
});

export { displayStyles as default };
